const trimUSA = (placeName) => {
    const termUSA = 'United States of America';
    const termUS = 'United States';

    const itemArray = placeName.split(', ');

    return ((itemArray[itemArray.length - 1] === termUSA || itemArray[itemArray.length - 1] === termUS) ? itemArray.pop() && itemArray.join(', ') : placeName)
}

export const prepInputObj = (result, rawText) => {
    // result can be 1 of 3 types of items:
    // - keyword(s) - a set of characters entered by the user (if this, then there is no .place_name, so it is just the value of .result)
    // - region, place, country, postcode - a geographic location, which can be city, state, and country (if this, we need to trim the country)
    // - organization - an organization name (if this, then we just want the .text attribute which is just the org name)

    const inputObj = {
        center: [], coordinates: [], place_name: '', place_type: "keyword", text: rawText, raw: rawText, type: result.type, validLocation: result.validLocation,
    };


    if (Object.prototype.hasOwnProperty.call(result, 'place_type')) {
        // user entered a found valid geographic location
        inputObj.center = result.center;
        inputObj.coordinates = result.geometry.coordinates;
        inputObj.place_name = trimUSA(result.place_name);
        inputObj.place_type = result.place_type[0];
        if (result.place_type[0] !== 'organization') {
            inputObj.text = inputObj.place_name;
            inputObj.validLocation = true;
        }
    }

    return inputObj;
}


// trimUSA = placeName => {
//     const itemArray = placeName.split(', ');

//     return itemArray[itemArray.length - 1] === 'United States' ? itemArray.pop() && itemArray.join(', ') : placeName;
// };